import { Content, GroupField } from '@prismicio/client';
import { Simplify } from '../../../../../../../prismicio-types';

import styles from './ourProcessTextCard.module.scss';

interface OurProcessTextCardProps {
  items: GroupField<
    Simplify<
      | Content.HeroSliceOurProcessPrimaryFirstColumnTextCardItem
      | Content.HeroSliceOurProcessPrimarySecondColumnTextCardItem
    >
  >;
  isVisible: boolean;
}

export const OurProcessTextCard = ({
  items,
  isVisible,
}: OurProcessTextCardProps) => {
  return (
    <div className={`${styles.card} ${isVisible ? styles.isVisible : ''}`}>
      {items.map((item) => (
        <div className={styles.item} key={item.heading}>
          <span className={styles.heading}>{item.heading}</span>
          <span className={styles.value}>{item.value}</span>
        </div>
      ))}
    </div>
  );
};
